module.exports = __webpack_public_path__ + "img/indications.84fee3d9.png";